import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, Formik } from 'formik';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { FieldTypes, SelectOptionFields, pureTextField } from 'drapcode-constant';
import * as actions from './redux/actions';
import CustomLoader from '../common/CustomLoader';
import { filterCollectionDefaultFields, filterFieldsForForm } from './../common/FieldTypes';
import {
  fieldSchema,
  fieldSchemaValidation,
  fileTypes,
} from '../../common/formElements/CollectionSectionType';
import { dynamicSort } from '../../common/utils/api_utils';
import { drapcodeIcon, iconForField } from '../../common/custom/icon-library';
import FieldFormFields from './fields/FieldFormFields';
import ParentDocCard from '../common/ParentDocCard';
import DocsLink from '../../common/custom/DocsLink';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import VideoBox from '../../common/custom/VideoBox';
import showAlert from '../../common/utils/alert';
import { renderDefaultFieldType } from '../../common/utils/field-options';
const { large_text } = FieldTypes;

export class AddCollectionField extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    showFieldType: true,
    selectedField: 'text',
    staticOptions: fieldSchema().staticOptions,
    tags: [],
    showAlert: false,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, collectionId, version } = match.params;
    actions.loadProjectDetailCollections({ projectId, version });
    actions.loadProjectCollections({ projectId, version });
    actions.loadProjectCollectionDetail({ projectId, collectionId, version });
  }

  handleTagDelete = (i) => {
    const tags = this.state.tags.filter((tag, index) => index !== i);
    this.setState({ tags });
  };

  handleTagAddition = (tag) => {
    this.setState({
      tags: [...this.state.tags, tag],
    });
  };

  collectionOptions = (isBelongTo = false) => {
    const { projectCollections, selectedCollection } = this.props.collections;
    let collectionToSelect = projectCollections;
    if (isBelongTo) {
      collectionToSelect = projectCollections.filter(
        (e) => e.collectionName !== selectedCollection.collectionName,
      );
    }

    return collectionToSelect.sort(dynamicSort('collectionTitle')).map((coll, index) => {
      return (
        <option key={index} value={coll.collectionName}>
          {coll.collectionTitle}
        </option>
      );
    });
  };

  handleSubmit = (values) => {
    values.type = this.state.selectedField;
    if (values.type === large_text.id) {
      values.validation = { ...values.validation, max: 1000 };
    }

    const { match, collections } = this.props;
    const { projectId, collectionId, version } = match.params;
    this.props.actions
      .createNewField({
        projectId,
        version,
        collectionName: collections.selectedCollection.collectionName,
        data: values,
      })
      .then((res) => {
        this.setState({
          showFieldType: true,
          selectedField: 'text',
          tags: [],
          showAlert: true,
        });
      });
  };

  showFieldForm = () => {
    const { selectedField, tags } = this.state;
    if (!selectedField) return '';

    const { collections } = this.props;
    const { projectCollections, projectDetail } = collections;

    return (
      <Formik
        enableReinitialize={true}
        initialValues={fieldSchema()}
        validationSchema={fieldSchemaValidation()}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          values.staticOptions = tags.map((e) => e.text);
          values.type = selectedField;
          if (SelectOptionFields.includes(values.type)) {
            values.refCollection.isShowAsText =
              values.refCollection.displayType === 'asText' ? true : false;
            values.refCollection.isShowAsRadioOrCheckBox =
              values.refCollection.displayType === 'asRadioOrCheckbox' ? true : false;
            values.refCollection.displayType =
              values.refCollection.displayType === 'asText' ||
              values.refCollection.displayType === 'asRadioOrCheckbox'
                ? 'dropdown'
                : values.refCollection.displayType;
          }
          values.unique = values.unique && pureTextField.includes(values.type) ? true : false;
          this.handleSubmit(values);
          setSubmitting(false);
          resetForm();
        }}
      >
        {({ isSubmitting, values, setFieldValue, setFieldTouched }) => (
          <Form className="form-horizontal">
            <div className="row mx-auto">
              <FieldFormFields
                values={values}
                setFieldValue={setFieldValue}
                selectedField={selectedField}
                setFieldTouched={setFieldTouched}
                projectCollections={projectCollections}
                changeFieldType={this.changeFieldType}
                handleTagDelete={this.handleTagDelete}
                handleTagAddition={this.handleTagAddition}
                tags={tags}
                collectionOptions={this.collectionOptions}
                projectDetail={projectDetail}
              />
            </div>
            <div className="col-md-12 col-lg-12 text-right">
              <button type="submit" className="btn btn-theme-submit btn-md" disabled={isSubmitting}>
                <i className="wb webconnect-save-regular"></i>&nbsp;&nbsp;Create Field
              </button>
            </div>
          </Form>
        )}
      </Formik>
    );
  };

  getFieldTypes = () => {
    return Object.keys(FieldTypes)
      .filter((key) => FieldTypes[key].show)
      .sort()
      .map((key) => ({ value: key, label: FieldTypes[key].name }));
  };

  changeFieldType = (newField) => {
    this.setState({ selectedField: newField });
  };

  toggleChooseFieldType = () => {
    this.setState({ showFieldType: !this.state.showFieldType });
  };

  cancelField = () => {
    this.setState({ showFieldType: false, selectedField: null });
  };

  deleteField = (fieldId) => {
    const { field, match, collections, actions } = this.props;
    const { selectedCollection } = collections;
    const { projectId, version } = match.params;
    const preConfirm = () => {
      actions.deleteField({
        fieldId,
        version,
        projectId,
        collectionName: selectedCollection.collectionName,
      });
    };
    showAlert("You won't be able to revert this.", preConfirm, 'Yes, delete it!');
  };

  showSelectedCollectionField = () => {
    const { selectedCollection } = this.props.collections;
    if (
      !selectedCollection ||
      !selectedCollection.fields ||
      selectedCollection.fields.length === 0
    ) {
      return '';
    }
    const defaultFields = filterCollectionDefaultFields(selectedCollection.fields);
    const fields = filterFieldsForForm(selectedCollection.fields);

    const collectionTenantfield =
      selectedCollection.fields &&
      selectedCollection.fields.find(
        (field) => field.isPluginField && field.fieldName === 'tenantId',
      );
    if (collectionTenantfield) {
      defaultFields.push({
        order: defaultFields.length + 1,
        defaultField: collectionTenantfield,
      });
    }

    const userSettingsField =
      selectedCollection.fields &&
      selectedCollection.fields.find(
        (field) => field.isPluginField && field.fieldName === 'userSettingId',
      );
    if (userSettingsField) {
      defaultFields.push({
        order: defaultFields.length + 1,
        defaultField: userSettingsField,
      });
    }

    const permissionsField =
      selectedCollection.fields &&
      selectedCollection.fields.find(
        (field) => field.isPluginField && field.fieldName === 'permissions',
      );
    if (permissionsField) {
      defaultFields.push({
        order: defaultFields.length + 1,
        defaultField: permissionsField,
      });
    }

    const userRolesField =
      selectedCollection.fields &&
      selectedCollection.fields.find(
        (field) => field.isPluginField && field.fieldName === 'userRoles',
      );
    if (userRolesField) {
      defaultFields.push({
        order: defaultFields.length + 1,
        defaultField: userRolesField,
      });
    }

    const userIdField =
      selectedCollection.isUserSettingCollection &&
      selectedCollection.fields &&
      selectedCollection.fields.find(
        (field) => field.isPluginField && field.fieldName === 'userId',
      );
    if (userIdField) {
      defaultFields.push({
        order: defaultFields.length + 1,
        defaultField: userIdField,
      });
    }

    const subTenantField =
      selectedCollection.fields &&
      selectedCollection.fields.find(
        (field) => field.isPluginField && field.fieldName === 'subTenantId',
      );
    if (subTenantField) {
      defaultFields.push({
        order: defaultFields.length + 1,
        defaultField: subTenantField,
      });
    }

    return (
      <>
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 table-responsive">
            {defaultFields.length > 0 || fields.length > 0 ? (
              <table className="table table-bordered table-hover table-sm table-word-break">
                <thead>
                  <tr>
                    <th>Field</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {defaultFields instanceof Array &&
                    defaultFields
                      .sort((a, b) => a.order - b.order)
                      .map((fieldObj) => (
                        <tr key={fieldObj.defaultField.fieldName}>
                          <td className="align-middle">
                            <strong>
                              <i className={`wb ${iconForField(fieldObj.defaultField.type)}`}></i>
                              &nbsp;&nbsp;{fieldObj.defaultField.fieldTitle.en}
                            </strong>{' '}
                            <small>{renderDefaultFieldType(fieldObj.defaultField.fieldName)}</small>
                          </td>
                          <td className="align-middle text-right">
                            <button className="btn btn-xs" title="" disabled={true}>
                              <i className="wb webconnect-trash"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                  {fields instanceof Array &&
                    fields
                      .filter(
                        (field) =>
                          ![
                            'tenantId',
                            'userSettingId',
                            'permissions',
                            'userRoles',
                            'userId',
                            'subTenantId',
                          ].includes(field.fieldName),
                      )
                      .map((field) => (
                        <tr key={field.fieldName}>
                          <td className="align-middle">
                            <strong>
                              <i className={`wb ${iconForField(field.type)}`}></i>
                              &nbsp;&nbsp;{field.fieldTitle.en}
                            </strong>
                            {field.isPluginField && field.fieldName === 'tenantId' && (
                              <small>&nbsp;(tenant default)</small>
                            )}
                            {field.isPluginField && field.fieldName === 'subTenantId' && (
                              <small>&nbsp;(Sub Tenant default)</small>
                            )}
                          </td>
                          <td className="align-middle text-right">
                            {field.isPluginField ? (
                              <button className="btn btn-xs" title="" disabled={true}>
                                <i className="wb webconnect-trash"></i>
                              </button>
                            ) : (
                              <button
                                className="btn btn-theme-delete btn-xs"
                                title=""
                                onClick={() => this.deleteField(field._id)}
                              >
                                <i className="wb webconnect-trash"></i>
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                </tbody>
              </table>
            ) : (
              <div>
                <h5 className="text-center">No Fields!</h5>
              </div>
            )}
          </div>
        </div>
      </>
    );
  };
  showAlertMessage = () => {
    return (
      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
        <div className="alert alert-success">
          <div className="alert-icon">
            <i className="wb webconnect-check2" style={{ verticalAlign: '0' }}></i>
          </div>
          <button
            type="button"
            className="close"
            data-dismiss="alert"
            aria-label="Close"
            title="Close"
            onClick={() => this.setState({ showAlert: false })}
          >
            <span aria-hidden="true">
              <i className="wb webconnect-x" style={{ verticalAlign: '0' }}></i>
            </span>
          </button>
          Success: The field has been added successfully! To view field click{' '}
          <a href="#collection-field" title="Fields">
            <span style={{ textDecoration: 'underline' }}>here</span>
          </a>
        </div>
      </div>
    );
  };

  render() {
    const { selectedField, showFieldType, showAlert } = this.state;
    const { match, collections } = this.props;
    const {
      loadProjectCollectionsPending,
      loadProjectCollectionDetailPending,
      selectedCollection,
    } = collections;
    const { projectId, collectionId, version } = match.params;
    const fields = selectedCollection ? filterFieldsForForm(selectedCollection.fields) : [];

    return (
      <CommonPageComponent parentClassName="">
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            {loadProjectCollectionsPending || loadProjectCollectionDetailPending ? (
              <div className="text-center">
                <CustomLoader
                  loading={loadProjectCollectionsPending || loadProjectCollectionDetailPending}
                  size="20px"
                  color="#303453"
                />
              </div>
            ) : (
              <>
                {showAlert && this.showAlertMessage()}
                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                  <div className="card">
                    <div
                      className="card-header card-header-icon"
                      data-background-color="drapcode-dark-blue"
                    >
                      <i className={`wb ${drapcodeIcon('form')}`}></i>
                    </div>
                    <div className="card-content">
                      <div className="card-title-header">
                        <h5 className="card-title">
                          Add Field{' '}
                          {typeof selectedCollection !== 'undefined' && selectedCollection
                            ? ' To ' + selectedCollection.collectionTitle
                            : ''}
                        </h5>
                        <div className="card-cta"></div>
                      </div>
                      {this.showFieldForm()}
                    </div>
                  </div>
                </div>

                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                  <div className="card" id="collection-field">
                    <div
                      className="card-header card-header-icon"
                      data-background-color="drapcode-dark-blue"
                    >
                      <i className={`wb ${drapcodeIcon('list')}`}></i>
                    </div>
                    <div className="card-content">
                      <div className="card-title-header">
                        <h5 className="card-title">Fields</h5>
                        <div className="card-cta"></div>
                      </div>
                      {this.showSelectedCollectionField()}
                    </div>
                  </div>
                </div>
                {fields.length > 0 ? (
                  <div className="row mx-auto">
                    <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12"></div>
                    <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 pt-4 text-right">
                      <Link
                        className="btn btn-primary btn-md"
                        to={`/collections/${version}/v/${projectId}/add-item/${collectionId}`}
                        title="Goto Next Step to Add Data"
                      >
                        <i className="wb webconnect-skip-forward-fill"></i> Add Data
                      </Link>
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </>
            )}
          </div>
          <ParentDocCard>
            <h5>
              <b>About Field</b>
            </h5>
            <p>
              After you have created a collection by naming it, add fields in it. Fields are the
              columns you want to add in your collection. These columns can be updated or deleted
              later on.
            </p>
            <DocsLink link="https://academy.drapcode.com/docs/app-collection/create-collection" />
            <br />
            <h5>
              <b>Multi-Step Form Flow with Reference Fields</b>
            </h5>
            <p>
              You can link everything to the main parent collection. For eg., while onboarding an
              employee data if you want to create several pages for collection such as Education,
              Previous Employer, Family Members and other details but want to link all of them to
              the main Employee collection only in the flow.
            </p>
            <DocsLink link="https://academy.drapcode.com/docs/app-collection/multi-step-form-flow-with-reference-fields" />
            <h5>
              <b>Passing Reference Field Value as Hidden Parameters</b>
            </h5>
            <p>
              There are several use cases where you need to pass the reference field as hidden form
              parameter and you should not input them manually. In such cases you can send the fixed
              UUID or user values from session or from the details page of any data easily.
            </p>
            <DocsLink link="https://academy.drapcode.com/docs/app-collection/passing-reference-field-value-as-hidden-parameters" />
            <br />
            <h5>
              <b>Videos</b>
            </h5>
            <VideoBox
              heading="Multi-Steps Form Flow with Reference Fields"
              imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/Multi-Steps+Form+Flow+with+Reference+Fields.jpg"
              videoLink="https://www.youtube.com/watch?v=qNyCayHL3_U"
            />
            <br />

            <VideoBox
              heading="Passing Reference Field Value as Hidden Parameters"
              imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/Passing+Reference+Field+Value+as+Hidden+Parameters.jpg"
              videoLink="https://www.youtube.com/watch?v=V47S1cBt1nM"
            />
          </ParentDocCard>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddCollectionField);
